import type { PropsWithChildren } from "react";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { FilterList } from "@tenant/hotels";
import { useHotelSlot } from "../../../../slots";
import defaultStyles from "./Filters.module.scss";

export const Filters = ({ children }: PropsWithChildren) => {
  const styles = useHotelsStyles(CoreHotelsComponent.Filters, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.Filters);

  const HotelSlot = useHotelSlot();

  return (
    <div className={block}>
      {children}
      <HotelSlot.FilterDialog />
      <FilterList className={cn("filter-list")} />
    </div>
  );
};
